<div class="position-relative row form-group prop-elems pl-0 pr-0" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
    <label class="col-sm-6 col-form-label" for="searchable-fields">{{'SEARCHABLE_FIELDS' | translate}}
        <i class="fa fa-info-circle field-info" showDelay="100" hideDelay="100" tooltipPosition="bottom"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{'SEARCHABLE_FIELDS_TOOLTIP_CONTENT' | translate}}"></i>
    </label>
    <div class="col-sm-6 p-0 input-ctrl" id="searchable-fields">
        <button type="button" style="display: flex !important;" class="btn btn-default p-button-icon-only"
            (click)="openSearchModal()"><i class="fa fa-edit pl-0"></i></button>
    </div>

</div>

<p-dialog
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'screens-modal-popup searchFields-container beta-access-enabled' : 'screens-modal-popup searchFields-container'"
  [(visible)]="showSearchModal"
  [modal]="true"
  [appendTo]="'body'"
  [draggable]="false"
  [style]="{ width: '75vw' }"
  [baseZIndex]="150"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <div>
      <span class="span-head"
        >{{ showHeader() | translate }}
        <span class="dialog-subheader" title="table"> {{ tableName }}</span>
      </span>
      <div class="search-form-control field-filter">
       
        <span class="search-icon">
          <i class="pi pi-search"></i>
        </span>
        <input
          *ngIf="activeTabIndex() === 0"
          type="text"
          class="form-control form-control-sm search-input-text"
          placeholder="Search"
          [(ngModel)]="searchValue"
          (input)="searchTbl.filterGlobal($event.target?.value, 'contains')"
        />
        <input
          *ngIf="activeTabIndex() === 1"
          type="text"
          class="form-control form-control-sm search-input-text"
          placeholder="Search"
          [(ngModel)]="foreignKeySearch"
          (input)="filterTree()"
        />
      </div>
    </div>
  </ng-template>

  <p-tabs [(value)]="activeTabIndex" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab [value]="0">Table Fields</p-tab>
      <p-tab [value]="1">Referenced Table Fields</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <ng-container
          *ngTemplateOutlet="
            searchFieldsTemplate;
            context: { hasFkFields: false, hasFields: true, Fields: allFields, columns: fieldCols }
          "
        ></ng-container>
      </p-tabpanel>
      <p-tabpanel [value]="1" *ngIf="foreignkeyMappings && fkCols">
        <ng-container
          *ngTemplateOutlet="
            searchFieldsTemplate;
            context: {
              hasFkFields: true,
              hasFields: false,
              Fields: filteredforeignkeyMappingsTreeNodes,
              columns: fkCols
            }
          "
        ></ng-container>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <ng-template
    #searchFieldsTemplate
    let-hasFkFields="hasFkFields"
    let-hasFields="hasFields"
    let-Fields="Fields"
    let-columns="columns"
  >
    <div class="mt-2 mb-2 search-fld-container" #searchcontainer>
      <p-treeTable
        #searchTbl
        [columns]="columns"
        [value]="Fields"
        dataKey="tableId"
        responsiveLayout="scroll"
        [scrollHeight]="'50vh'"
        [autoLayout]="true"
        id="add_key_table"
        [scrollable]="true"
        styleClass="p-datatable-sm eva-v2-table-container"
        (onNodeExpand)="onNodeExpand($event)"
        (onNodeCollapse)="onNodeCollapse($event)"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th class="{{ col.field }}" scope="col">
                {{ col.header | translate }}
                <i
                  *ngIf="col.field === 'propagate'"
                  class="fa fa-info-circle field-info tblInfo"
                  tooltipPosition="left"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  [pTooltip]="tooltipTemplate"
                  [escape]="false"
                ></i>
                <i
                  *ngIf="col.field !== 'propagate' && col.field !== 'name' && col.field !== 'foreignkey'"
                  class="fa fa-info-circle field-info tblInfo"
                  tooltipPosition="bottom"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  pTooltip="{{ col.infoBubble | translate }}"
                ></i>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr class="{{ rowNode.level === 1 ? 'childLevel' : 'parentLevel' }}">
            <!-- Name Column -->
            <td class="tbl-{{ rowNode.level }} {{ hasFkFields ? 'foreignkey' : 'name' }}">
              <div class="w-100 d-flex align-items-center">
                <p-treeTableToggler *ngIf="rowData.showChild && !hasFields" [rowNode]="rowNode"> </p-treeTableToggler>
                <span *ngIf="!rowData.showChild">{{ rowData.name }}</span>
                <span *ngIf="rowData.showChild">{{ rowData.name?.split('+')[0] }}</span>
                <span class="tabl-label" *ngIf="rowData.showChild" title="table">{{
                  rowData.name?.split('+')[1]
                }}</span>
                <i
                  *ngIf="rowData.mappedField"
                  class="fa fa-info-circle field-info tblInfo"
                  tooltipPosition="bottom"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  pTooltip="Only non-mapped fields can be selected for configuration."
                ></i>
                <span class="map-fld-label" *ngIf="rowData.mappedField" title="table">{{ fieldIdMap[rowData.mappedField] }}</span>
              </div>
            </td>

            <!-- Searchable Checkbox -->
            <td class="searchable">
              <p-checkbox
                *ngIf="!rowData.showChild"
                [binary]="true"
                [(ngModel)]="rowData.searchable"
                [disabled]="disableCheckBox(rowData, 'searchable') || rowData.mappedField"
                (onChange)="onCheckboxChange($event, rowData)"
              ></p-checkbox>
            </td>

            <!-- Partial Search Checkbox -->
            <td class="partialSearch">
              <p-checkbox
                *ngIf="rowData.isString && !partialSearchRestricted.includes(rowData.name) && !rowData.showChild"
                [binary]="true"
                [(ngModel)]="rowData.partialSearch"
                [disabled]="disableCheckBox(rowData, '') || !rowData.searchable || rowData.mappedField"
                (onChange)="onCheckboxChange($event,rowData)"
              ></p-checkbox>
            </td>

            <!-- Propagate Checkbox -->
            <td class="propagate" *ngIf="hasFkFields">
              <p-checkbox
                *ngIf="!rowData.showChild"
                [binary]="true"
                [(ngModel)]="rowData.propagate"
                [disabled]="disableCheckBox(rowData, '') || !rowData.searchable || rowData.mappedField"
                (onChange)="onCheckboxChange($event,rowData)"
              ></p-checkbox>
            </td>

            <!-- FK Alias Name Input -->
            <td class="fkAliasName" *ngIf="hasFkFields">
              <input
                *ngIf="!rowData.showChild && rowData.searchable"
                [(ngModel)]="rowData.fkAliasName"
                [disabled]="disableCheckBox(rowData, '') || rowData.mappedField"
                (blur)="validateBeforeSave($event, rowData)"
                (keydown.enter)="validateBeforeSave($event, rowData)"
              />
              <div *ngIf="isloading" class="loader">
                <p-progress-spinner></p-progress-spinner>
              </div>
            </td></tr
        ></ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr class="no-records">
            <td colspan="2" class="text-center">
              {{ 'NO_RECORDS_FOUND' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
    <div *ngIf="isloading" class="d-flex justify-content-center align-items-center w-100">
      <div class="spinners">
        <p-progress-spinner></p-progress-spinner>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeAddFieldsModalDialogue()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="updateFields()">{{ 'SAVE' | translate }}</button>
  </ng-template>
</p-dialog>
